import { OpcionSelect } from "src/components/input/TextInput";



export enum RolesId {
	ADMIN = 'ADMIN',
	GESTOR = 'GESTOR',
	ASESOR = 'COORDINADOR',
}

export const opcionesTipoDocumento: OpcionSelect[] = [
	{valor: 'CC', label: 'Cédula de ciudadanía'},
	{valor: 'CE', label: 'Cédula de extranjería'},
	{valor: 'TI', label: 'Tarjeta de identidad'},
	{valor: 'PAP', label: 'Pasaporte'},
];

export const opcionesTipoIdentificacionPersonasJuridicas: OpcionSelect[] = [
	{valor: 'NIT', label: 'NIT - Números de Identificación Tributaria'},
	{valor: 'RUT', label: 'RUT - Registro Único Tributario'},
	{valor: 'CIF', label: 'CIF - Código de Identificación Fiscal de una empresa'},
	{valor: 'NIF', label: 'NIF - Número de Identificación Fiscal'},
];

export const opcionesTipoIdentificacionPersonaNatural: OpcionSelect[] = [
	{valor: 'CEDULA_DE_CIUDADANIA', label: 'Cédula de ciudadanía'},
];

export enum TipoExperienciaEnum {
	NO_DOCENCIA = 'NO_DOCENCIA',
	DOCENCIA = 'DOCENCIA',
}

export const opcionesTipoExperiencia: OpcionSelect[] = [
	{valor: TipoExperienciaEnum.NO_DOCENCIA, label: 'Experiencia empresarial o en la industria'},
	{valor: TipoExperienciaEnum.DOCENCIA, label: 'Docencia'},
];

export enum EstadoAspirante {
		SUBSANACION ="SUBSANACION",
		ENVIADO_MINTIC ="ENVIADO_MINTIC",
		PENDIENTE_INFORMACION ="PENDIENTE_INFORMACION",
		CONSOLIDADO_MATRIZ ="CONSOLIDADO_MATRIZ",
		EN_REVISION ="EN_REVISION",
		APROBADO ="APROBADO",
		RECHAZADO ="RECHAZADO",
		SUBSANACION_INFORMACION_RECIBIDO ="SUBSANACION_INFORMACION_RECIBIDO",
		RECIBIDO = "RECIBIDO",
		ASIGNADO_MATRIZ = "ASIGNADO_MATRIZ",
		RECIBIDO_INFORMACION ="RECIBIDO_INFORMACION",
		SUBSANACION_PENDIENTE_INFORMACION = "SUBSANACION_PENDIENTE_INFORMACION"
}

export const ESTADOS_ASPIRANTE_DESCRIPCION: OpcionSelect[] = [
    { valor: EstadoAspirante.SUBSANACION, label: "Subsanación"},
    { valor: EstadoAspirante.ENVIADO_MINTIC, label: "Enviado Min Tic"},
    { valor: EstadoAspirante.PENDIENTE_INFORMACION, label: "Pendiente Información"},
    { valor: EstadoAspirante.CONSOLIDADO_MATRIZ, label: "Consolidado Matriz"},
    { valor: EstadoAspirante.EN_REVISION, label: "En revisión"},
    { valor: EstadoAspirante.APROBADO, label: "Aprobado"},
    { valor: EstadoAspirante.RECHAZADO, label: "Rechazado"},
    { valor: EstadoAspirante.SUBSANACION_INFORMACION_RECIBIDO, label: "Recibido - Subsanación de información"},
    { valor: EstadoAspirante.RECIBIDO, label: "Recibido"},
    { valor: EstadoAspirante.ASIGNADO_MATRIZ, label: "Asignado Matriz"},
    { valor: EstadoAspirante.RECIBIDO_INFORMACION, label: "Recibido información"},
    { valor: EstadoAspirante.SUBSANACION_PENDIENTE_INFORMACION, label: "Pendiente - Subsanación de información"},
    ];

	export const obtenerOpcionesEstadosAspirante = (roles: EstadoAspirante[]): OpcionSelect[] => {
		return ESTADOS_ASPIRANTE_DESCRIPCION.filter((estado) => roles.includes(estado.valor as EstadoAspirante));
	  }; 

	  export const decodificarEstadoAspirante = (rol: EstadoAspirante): string => {
		return ESTADOS_ASPIRANTE_DESCRIPCION.find((estado) => rol ===(estado.valor))?.label as string || '';
	  }; 
	

export const opcionesSexo: OpcionSelect[] = [
	{ valor: 'MASCULINO', label: 'Masculino' },
	{ valor: 'FEMENINO', label: 'Femenino' },
	{ valor: 'OTRO', label: 'Otro' },
  ];

export const enum TipoEmpresa {
	PRIVADA = 'PRIVADA',
	PUBLICA = 'PUBLICA',
	MIXTA = 'MIXTA',
}

export const opcionesNivelEstudios: OpcionSelect[] = [
	{valor: 'ESTUDIANTE', label: 'Estudiante'},
	{valor: 'TECNICO', label: 'Técnico'},
	{valor: 'TECNOLOGO', label: 'Tecnólogo'},
	{valor: 'PROFESIONAL', label: 'Profesional'},
];

export const opcionesTipoInstitucion: OpcionSelect[] = [
	{valor: TipoEmpresa.PRIVADA, label: 'Privada'},
	{valor: TipoEmpresa.PUBLICA, label: 'Pública'},
	{valor: TipoEmpresa.MIXTA, label: 'Mixta'},
];


export type TipoUsuario = 'INSTITUCIONAL' | 'NO_INSTITUCIONAL';

export const enum TipoUsuarioEnum {
	INSTITUCIONAL = 'INSTITUCIONAL',
	NO_INSTITUCIONAL = 'NO_INSTITUCIONAL',
}
